export default "__VITE_ASSET__092377b5__"